import { MeRepository } from 'common/repositories/index';

angular.module('resolvers').myaToken = ($q) => {

    const deferred = $q.defer();

    if (MeRepository.getMyaHash()) {

        deferred.resolve();

    }

    return deferred.promise;

};

angular.module('resolvers').myaToken.$inject = ['$q'];



// WEBPACK FOOTER //
// ./scripts/common/resolvers/myaToken.js